import { breakpoints } from '@naf/theme';
import styled from '@emotion/styled';

// Width is set to overlap the 44px width of NAF logo
export const EasterWrapper = styled.div`
  height: auto;
  width: 103px;
  transform: translateX(-9px);

  @media (min-width: ${breakpoints.m}) {
    transform: translateX(-6px);
  }

  @media (min-width: ${breakpoints.l}) {
    width: 112px;
    transform: translate(7px, 8px);
  }
`;
